import { Column, Entity, Index, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { NotificationAutoResponseEntity } from './notification-auto-response.entity';
import { PhonePhoneTopicEntity } from './phone-phone-topic.entity';

@Index('unique_phone_number', ['number'], { unique: true })
@Index('unique_topic_name', ['name'], { unique: true })
@Entity('_phone_topic')
export class PhoneTopicEntity extends BaseEntity {
	@Column('varchar', { name: '_name', unique: true, length: 50 })
	public name!: string;

	@Column('varchar', { name: '_number', unique: true, length: 20 })
	public number!: string;

	@Column('varchar', { name: '_title', length: 50 })
	public title!: string;

	@Column('varchar', { name: '_help', length: 100 })
	public help!: string;

	@OneToMany(
		() => NotificationAutoResponseEntity,
		(notificationAutoResponse) => notificationAutoResponse.fkPhoneTopic,
		{},
	)
	public notificationAutoResponses!: Array<NotificationAutoResponseEntity>;

	@OneToMany(
		() => PhonePhoneTopicEntity,
		(phonePhoneTopic) => phonePhoneTopic.fkPhoneTopic,
		{},
	)
	public phonePhoneTopics!: Array<PhonePhoneTopicEntity>;
}
